import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, lighten, Typography, useTheme } from "@mui/material";

const formatType = (type) => {
  return type.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
};

const CodingDetails = ({ category_details }) => {
  const theme = useTheme();
  const rows = Object.entries(category_details).map(([key, value], index) => ({
    id: index,
    type: formatType(value.type),
    category: key,
    description: value.category_description,
    removed: value.dropped_categories?.join(", ") || "",
    diagnosis_codes: value.diagnosis_map?.join(", ") || "",
    score: value.coefficient || 0,
  }));

  const columns = [
    { field: "type", headerName: "Type", flex: 1, headerClassName: "header" },
    {
      field: "category",
      headerName: "HCC Category",
      flex: 1,
      headerClassName: "header",
    },
    {
      field: "description",
      headerName: "HCC Category Definition",
      flex: 2,
      headerClassName: "header",
    },
    {
      field: "removed",
      headerName: "Removed HCC Categories",
      flex: 1.5,
      headerClassName: "header",
    },
    {
      field: "diagnosis_codes",
      headerName: "Diagnosis Codes",
      flex: 1.5,
      headerClassName: "header",
    },
    {
      field: "score",
      headerName: "RAF Score",
      flex: 1,
      headerClassName: "header",
    },
  ];

  return (
    <Box mt={4} m={2}>
      <Typography variant="h6" gutterBottom>
        Coding Details
      </Typography>
      <DataGrid
        autoHeight
        rows={rows}
        columns={columns}
        pageSize={5}
        disableRowSelectionOnClick
        sx={{
          "& .header": {
            backgroundColor: lighten(theme.palette.primary.main, 0.6),
            color: "white",
            fontWeight: "bold",
          },
        }}
      />
    </Box>
  );
};

export default CodingDetails;
